import React, { useState, useEffect } from "react";
import { message } from "antd";
import { imgPath } from "../../../utils/axiosInstance";
import Logo from "../../../assets/logo.png";
import { GetDashboardServiceProviders } from "../../../utils/api";
import Loader from "../../shared/Loader";

const MostViewedServiceProviders = () => {
  const [serviceProviders, setServiceProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const response = await GetDashboardServiceProviders();
        setServiceProviders(response?.items);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        message.error(
          error || "Unknown error occured. Please try again later."
        );
      }
    };
    fetch();
  }, []);
  return (
    <div className="sm:w-3/12 w-full flex-1 py-4 box-shadow rounded-xl">
      <div className="flex items-start justify-between pb-2 px-4">
        <h2 className="text-sm font-semibold">Most Viewed Service Providers</h2>
      </div>
      <div className="overflow-y-scroll h-[242px] no-scrollbar">
        {loading && (
          <div className="w-full h-full flex justify-center items-center">
            <Loader height="230px" />
          </div>
        )}
        {serviceProviders &&
          serviceProviders?.length > 0 &&
          serviceProviders?.map((serviceProvider) => {
            return (
              <div
                key={serviceProvider?.id}
                className="flex items-center justify-between py-2 px-4 border-bottom"
              >
                <div className="flex gap-x-2 text-lightGray">
                  <img
                    src={
                      serviceProvider?.image
                        ? `${imgPath}${serviceProvider?.image}`
                        : Logo
                    }
                    alt={serviceProvider?.business_name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div className="flex flex-col gap-y-1 justify-center items-start">
                    <span
                      className={
                        "text-black-700 text-xs font-semibold 2xl:text-sm"
                      }
                    >
                      {serviceProvider.business_name}
                    </span>
                    <span className={"text-black-700 font-medium text-xs"}>
                      @{serviceProvider?.user_name}
                    </span>
                  </div>
                </div>
                <span
                  className={
                    "text-[11px] 2xl:text-[11px] font-medium mt-5 text-lightGray"
                  }
                >
                  {serviceProvider?.profile_view} views
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MostViewedServiceProviders;
